/**
 * Handles subnav functionality.
 */

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

gsap.registerPlugin( ScrollTrigger, ScrollToPlugin );

( function( $ ) {

    const className = 'js-subnav';
    const selector = `.${className}`;
    const selectSelector = `${selector}__select`;
    const itemSelector = `${selector}__item`;
    const linkSelector = `${selector}__link`;
    const columnSelector = '.js-subnav-column';
    const contentColumnSelector = '.js-subnav-content-column';

    const breakpoint = 981;

    const sectionDataVar = 'section';
    const activeClass = 'is-active';    

    let viewportOffset = 0;
    const viewportOffsetGoose = 8; // I hate this, but whatever — it works for now


    // Main methods (lolol)

    function setSelect( subnav, val ) {
        const select = subnav.find( selectSelector );
        select.val( val );
    }

    function setTriggers( subnav ) {

        const items = subnav.find( itemSelector );
        const links = subnav.find( linkSelector );
        const sectionSelectors = links.toArray().map( ( link ) => link.dataset[ sectionDataVar ] );
        const sections = $( sectionSelectors.join( ',' ) ).toArray();

        for ( let [ i, section ] of sections.entries() ) {

            ScrollTrigger.create(
                {
                    trigger     : section,
                    start       : () => `top ${viewportOffset}px`,
                    end         : () => `+=${getSectionHeight( i, sections )}`,
                    onEnter     : ( { trigger } ) => handleEnter( trigger, subnav ),
                    onEnterBack : ( { trigger } ) => handleEnter( trigger, subnav ),
                    onLeave     : i === sections.length - 1 ? () => setSelect( subnav, 0 ) : null,
                    onLeaveBack : i ? null : () => setSelect( subnav, 0 ),
                    toggleClass : {
                        targets   : items.toArray()[i],
                        className : activeClass
                    }
                }
            )
        }
    }

    function scrollTo( sectionSelector ) {
        gsap.to( window, { scrollTo: { y: sectionSelector, offsetY: viewportOffset - viewportOffsetGoose } } )
    }

    // Events

    function handleEnter( section, subnav ) {
        setSelect( subnav, `#${section.getAttribute( 'id' )}` );
    }

    // Utils

    function setViewportOffset( subnav, subnavColumn ) {

        const stickyElementStyle = window.innerWidth >= breakpoint
            ? getComputedStyle( subnav )
            : getComputedStyle( subnavColumn )

        const backgroundPseudoStyle = getComputedStyle( subnav, ':before' );

        const top = parseInt( stickyElementStyle.getPropertyValue( 'top' ) ) || 0;
        const pseudoHeight = parseInt( backgroundPseudoStyle.getPropertyValue( 'height' ) ) || 0;
        
        viewportOffset = top + pseudoHeight;
    }

    function getSectionHeight( i, sections ) {

        const sectionEl = sections[i];
        const section = $( sections[i] );
        const sectionRect = sectionEl.getBoundingClientRect();

        let bottomBound;

        if ( i === sections.length - 1 ) {
            const contentColumn = section.closest( contentColumnSelector );
            const contentColumnRect = contentColumn.get( 0 ).getBoundingClientRect();
            bottomBound = contentColumnRect.bottom;
        }
        else {
            const nextSectionEl = sections[i + 1];
            const nextSectionRect = nextSectionEl.getBoundingClientRect();
            bottomBound = nextSectionRect.top;
        }

        const height = Math.abs( bottomBound - sectionRect.top );
        return height
    }

    // Initialize

    $( window ).load( function() {

        const subnavs = $( selector );
        const subnavColumns = $( columnSelector );

        if ( subnavs.length && subnavColumns.length ) {

            // Setup

            setViewportOffset( subnavs.get( 0 ), subnavColumns.get( 0 ) );

            subnavs.each( ( i, subnav ) => {
                subnav = $( subnav );
                setTriggers( subnav );
            } )

            // Events

            const allLinks = $( linkSelector );
            const allSelects = $( selectSelector );

            allLinks.on( 'click', ( e ) => scrollTo( e.target.dataset[ sectionDataVar ] ) )

            allSelects.on( 'change', ( e ) => {
                const val = $( e.target ).val();
                if ( val ) {
                    scrollTo( val );
                }
            } )

            $( window ).on( 'resize', () => setViewportOffset( subnavs.get( 0 ), subnavColumns.get( 0 ) ) )
        }        

    } );
    
} )( jQuery );